import type { Routes } from '@angular/router'

export const LEGACY_REDIRECT_ROUTES = [
  {
    path: 'next/deactivate',
    redirectTo: 'next/settings/deactivate',
  },
  {
    path: 'next/deactivate/privacy',
    redirectTo: 'next/settings/deactivate/privacy',
  },
  {
    path: 'next/deactivate/confirm',
    redirectTo: 'next/settings/deactivate/confirm',
  },
  {
    path: 'next/profilev3/:id',
    redirectTo: 'next/profile/:id',
    pathMatch: 'full',
  },
  {
    path: 'next/v3/edit-profile',
    redirectTo: 'next/me/about',
    pathMatch: 'full',
  },
  {
    path: 'next/v3/verifications',
    redirectTo: 'next/me/verifications/',
    pathMatch: 'full',
  },
  {
    path: 'next/v3/verifications/:vType',
    redirectTo: 'next/me/verifications',
  },
  {
    path: 'next/edit-profile',
    pathMatch: 'full',
    redirectTo: 'next/me/about',
  },
  {
    path: 'next/photos',
    redirectTo: 'next/me/photos',
    pathMatch: 'full',
  },
  {
    path: 'next/videos',
    redirectTo: 'next/me/videos',
    pathMatch: 'full',
  },
  {
    path: 'next/verifications',
    redirectTo: 'next/me/verifications/',
    pathMatch: 'full',
  },
  {
    path: 'next/verifications/:vType',
    redirectTo: 'next/me/verifications',
  },
  {
    path: 'next/me/verifications/:vType',
    redirectTo: 'next/me/verifications',
  },
] as const satisfies Routes
